import { Page } from '@/core/architecture'

import { ConsoleMembershipDetailTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleMembershipDetail Page
 * Implemented as a practical sample.
 */
export const ConsoleMembershipDetail: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleMembershipDetailTemplate state={state} {...actions} />
}
